import { MYDIBEL_LOGO_2, NL_MHANDTBRUNOM, NL_ZHANDTBRUNOM, NL_MHANDTFREDERIKD, NL_ZHANDTFREDERIKD, FR_MHANDTBRUNOM, FR_ZHANDTBRUNOM, FR_MHANDTFREDERIKD, FR_ZHANDTFREDERIKD } from '../Config/images';
import { GetTranslatedValue } from './translationHelper';
import {
    DOCUMENTTEXTTYPE_NAME_TITLE, DOCUMENTTEXTTYPE_NAME_CONDITIONS, DOCUMENTTEXTTYPE_CODE_APPR_BOX_BRUNO_WITH_SIGNATURE,
    DOCUMENTTEXTTYPE_CODE_APPR_BOX_BRUNO_WITHOUT_SIGNATURE, DOCUMENTTEXTTYPE_CODE_APPR_BOX_FREDERIK_WITH_SIGNATURE,
    DOCUMENTTEXTTYPE_CODE_APPR_BOX_FREDERIK_WITHOUT_SIGNATURE, DOCUMENTTEXTTYPE_NAME_SIGNATURES
} from '../Config/documentTextTypes';
import AddFormProductsComponent from '../Components/StepComponents/AddFormProductsComponent';

var _mustache = require('mustache');
var _localStore = null;
var _purchaseOrder = null;

function ToCurrencyString(input) {
    if (typeof input !== 'number') {
        input = input.split(",").join(".");
    }
    return parseFloat(input).toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
}

function ToFormattedDate(input) {
    console.log("ToFormattedDate, input:");
    console.log(input);
    input = new Date(input);
    console.log(input);
    var mm = input.getMonth() + 1; // getMonth() is zero-based
    var dd = input.getDate();

    return [(dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, input.getFullYear()].join('/');
}

function CreateOrderLinesHtml(lines, languageID) {
    let rowsHtml = '';

    let rowHtml = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto.PurchaseOrderTypeID === _purchaseOrder.purchaseOrderTypeID
                && dto.DocumentTextCode === 'PURCHASEORDERLINEROW'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    let lastRowHtml = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto.PurchaseOrderTypeID === _purchaseOrder.purchaseOrderTypeID
                && dto.DocumentTextCode === 'PURCHASEORDERLINELASTROW'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    var lastRowIndex = lines.length - 1;

    lines.forEach((item, index, array) => {
        let currentRowHtml = rowHtml;
        if (index === lastRowIndex) {
            currentRowHtml = lastRowHtml;
        }

        let product = _localStore.products.find((p) => { return p.ID === item.productID });
        let productName = GetTranslatedValue(languageID, product.NameTranslationID, _localStore.translations, _localStore.translationValues);

        let uom = _localStore.unitOfMeasurements.find((u) => { return u.ID === item.unitOfMeasurementID });
        let uomName = GetTranslatedValue(languageID, uom.ReportingNameTranslationID, _localStore.translations, _localStore.translationValues, uom.ReportingName);

        console.log(item.fromDate);
        console.log(item.toDate);


        var currentRowData = {
            from: ToFormattedDate(item.fromDate),
            to: ToFormattedDate(item.toDate),
            articleName: productName,
            quantity: ToCurrencyString(item.quantity),
            unitOfMeasurement: uomName,
            unitPricePer100Kg: ToCurrencyString(parseFloat(item.unitPrice100Kg))
        }

        rowsHtml = rowsHtml + _mustache.render(currentRowHtml, currentRowData);
    });

    return rowsHtml;
}

function CreateTotalLineHtml(lines, unitOfMeasurementID, languageID) {
    let total = 0;

    let html = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto.PurchaseOrderTypeID === _purchaseOrder.purchaseOrderTypeID
                && dto.DocumentTextCode === 'PURCHASEORDERLINETOTALROW'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    lines.forEach((item, index, array) => {
        total += parseFloat(item.quantity);
    });

    console.log("Totaal gewicht product tabel:");
    console.log(total);

    let uom = _localStore.unitOfMeasurements.find((u) => { return u.ID === unitOfMeasurementID });
    let uomName = GetTranslatedValue(languageID, uom.ReportingNameTranslationID, _localStore.translations, _localStore.translationValues, uom.ReportingName);

    return _mustache.render(html, { totalQuantity: ToCurrencyString(total), unitOfMeasurement: uomName });
}

function CreateRemarksAndFreeClausesHtml(purchaseOrder, languageID) {
    purchaseOrder.remark = purchaseOrder.remark.split("\n").join("<br/>");

    let remarksAndFreeClauses = purchaseOrder.remark;
    remarksAndFreeClauses = remarksAndFreeClauses.concat("<br/>");
    let freeClausesString = ""
    var i;
    for (i = 0; i < purchaseOrder.selectedFreeClauses.length; i++) {
        var information = GetTranslatedValue(languageID, purchaseOrder.selectedFreeClauses[i].InformationTranslationID, _localStore.translations, _localStore.translationValues, purchaseOrder.selectedFreeClauses[i].Information);
        freeClausesString = freeClausesString.concat(information);
    }

    remarksAndFreeClauses = remarksAndFreeClauses.concat(freeClausesString)
    // _mustache.render(remarksAndFreeClauses, { remarks: remarksAndFreeClauses, supplier, certNumber, certValidUntil })

    let html = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto.PurchaseOrderTypeID === _purchaseOrder.purchaseOrderTypeID
                && dto.DocumentTextCode === 'REMARKSSECTION'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    return _mustache.render(html, { remarks: remarksAndFreeClauses });
}

function CreateContractConditionsSectionHtml(contractConditions, languageID) {
    if (!contractConditions || contractConditions.length === 0) { return ''; }

    contractConditions = contractConditions.sort(function (a, b) {
        if (a.SortOrder > b.SortOrder) {
            return 1;
        }
        if (b.SortOrder > a.SortOrder) {
            return -1;
        }
        return 0;
    });

    let contractConditionsHtml = "";

    contractConditions.forEach((item, index, array) => {
        contractConditionsHtml += item.DocumentTextInformation;
    });

    let html = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto.PurchaseOrderTypeID === _purchaseOrder.purchaseOrderTypeID
                && dto.DocumentTextCode === 'CONDITIONSSECTION'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    return _mustache.render(html, { contractConditions: contractConditionsHtml });
}

function CreateValidUntillSection(purchaseOrder, languageID, languageCode) {
    if (!purchaseOrder.validUntillDate) { return ''; }

    let html = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto._purchaseOrderTypeID === _purchaseOrder._purchaseOrderTypeID
                && dto.DocumentTextCode === 'VALIDUNTILLSECTION'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    return _mustache.render(html, { date: new Date(purchaseOrder.validUntillDate).toLocaleString(languageCode, { month: 'long', day: 'numeric', year: 'numeric' }) });
}

function CreateSignatureApprovalBoxBruno(brokerIsExternal, validUntillDate, languageIsoCode) {
    let boxImage = '';

    if (brokerIsExternal || validUntillDate) {
        // docTextTypeCode = DOCUMENTTEXTTYPE_CODE_APPR_BOX_BRUNO_WITHOUT_SIGNATURE
        if (languageIsoCode === 'FR') {
            boxImage = FR_ZHANDTBRUNOM;
        }
        else {
            boxImage = NL_ZHANDTBRUNOM;
        }
    }
    else {
        if (languageIsoCode === 'FR') {
            boxImage = FR_MHANDTBRUNOM;

        }
        else {
            boxImage = NL_MHANDTBRUNOM;
        }
    }

    let html = `<div class="forApprovalBox">    
                    <img id="signBruno" width=140 height=142 src="{{boxImage}}">
                </div>`;

    return _mustache.render(html, { boxImage: boxImage });
}

function CreateSignatureApprovalBoxFrederik(brokerIsExternal, validUntillDate, languageIsoCode) {
    let boxImage = '';

    if (brokerIsExternal || validUntillDate) {
        if (languageIsoCode === 'FR') {
            boxImage = FR_ZHANDTFREDERIKD;
        }
        else {
            boxImage = NL_ZHANDTFREDERIKD;
        }
    }
    else {
        if (languageIsoCode === 'FR') {
            boxImage = FR_MHANDTFREDERIKD;
        }
        else {
            boxImage = NL_MHANDTFREDERIKD;
        }
    }

    let html = `<div class="forApprovalBox">    
                    <img id="signFrederik" width=140 height=142 src="{{boxImage}}">
                </div>`;

    return _mustache.render(html, { boxImage: boxImage });
}

function CreateBrokerApprovalBox(broker, languageID) {
    if (broker.IsManager) { return ''; }

    let html = _localStore.documentTextOverview.filter(
        (dto) => {
            return dto._purchaseOrderTypeID === _purchaseOrder._purchaseOrderTypeID
                && dto.DocumentTextCode === 'AMA_APPROVALBOX'
                && dto.LanguageID === languageID
        }
    )[0].DocumentTextInformation;

    return _mustache.render(html, { brokerName: broker.Name });
}

function CreateErrorHtml(error) {
    var html = `
        <p>Contract generation failed!</p>
        <br/><br/>
        <p>Error info: </p>
        <p>Name:{{errorName}}</p>
        <p>Description: {{errorMessage}}<br/>{{stackTrace}}</p>
    `;

    return _mustache.render(html, { errorMessage: error.message, errorName: error.name, stackTrace: error.stack });
}

export function CreateContractHtml(purchaseOrder, localStore) {
    try {
        _localStore = localStore;
        _purchaseOrder = purchaseOrder;

        // console.log(purchaseOrder.vendorID);

        let supplier = _localStore.suppliers.find((s) => { return s.ID === purchaseOrder.vendorID });

        // for(var propName in supplier) {
        //     propValue = supplier[propName]
        //     console.log(propName,propValue);
        // }

        let language = _localStore.languages.find((l) => { return l.ID === supplier.LanguageID });
        console.log(language)

        let baseHtml = _localStore.documentTextOverview.filter(
            (dto) => {
                return dto.PurchaseOrderTypeID === purchaseOrder.purchaseOrderTypeID
                    && dto.DocumentTextCode === 'BASEHTML'
                    && dto.LanguageID === supplier.LanguageID
            }
        )[0].DocumentTextInformation;

        let contractHtml = baseHtml;

        let purchaseOrderType = _localStore.purchaseOrderTypes.find((pot) => { return pot.ID === purchaseOrder.purchaseOrderTypeID });
        let uom = _localStore.unitOfMeasurements.find((u) => { return u.ID === purchaseOrder.unitOfMeasurementID });

        let supplierCountry = _localStore.countries.find((c) => { return c.ID === supplier.CountryID });
        let supplierCountryName = GetTranslatedValue(supplier.LanguageID, supplierCountry.NameTranslationID, _localStore.translations, _localStore.translationValues, supplierCountry.Name);

        let title = '';
        let titles = _localStore.documentTextOverview.filter(
            (dto) => {
                return dto.PurchaseOrderTypeID === purchaseOrder.purchaseOrderTypeID
                    && dto.DocumentTextTypeName === DOCUMENTTEXTTYPE_NAME_TITLE
                    && dto.LanguageID === supplier.LanguageID
            }
        );

        if (titles.length > 0) {
            title = titles[0].DocumentTextInformation;;
        }
        let declarartionTitle = 'Contract ' + purchaseOrder.externalReference;

        let contractConditions = _localStore.documentTextOverview.filter(
            (dto) => {
                return dto.PurchaseOrderTypeID === purchaseOrder.purchaseOrderTypeID
                    && dto.DocumentTextTypeName === DOCUMENTTEXTTYPE_NAME_CONDITIONS
                    && dto.LanguageID === supplier.LanguageID
            }
        );

        if (purchaseOrderType.Code === 'CONTRMYD') {
            if (uom.Code !== 'HA') {
                // don't show MYDCONTRCOND5
                contractConditions = _localStore.documentTextOverview.filter(
                    (dto) => {
                        return dto.PurchaseOrderTypeID === purchaseOrder.purchaseOrderTypeID
                            && dto.DocumentTextTypeName === DOCUMENTTEXTTYPE_NAME_CONDITIONS
                            && dto.LanguageID === supplier.LanguageID
                            && dto.DocumentTextCode !== 'MYDCONTRCOND5'
                    }
                );
            }
        }

        let broker = _localStore.brokers.find((b) => { return b.ID === purchaseOrder.brokerID });

        let approvalBoxBruno = CreateSignatureApprovalBoxBruno(broker.IsExternal, purchaseOrder.validUntillDate, language.LanguageIsoCode);
        let approvalBoxFrederik = CreateSignatureApprovalBoxFrederik(broker.IsExternal, purchaseOrder.validUntillDate, language.LanguageIsoCode);

        let certificateNumber = ""
        let validUntil = ""
        if (purchaseOrder.certificateInfo) {
            certificateNumber = purchaseOrder.certificateInfo.number
            validUntil = purchaseOrder.certificateInfo.validUntil
        }
        // Fields replaing in HTML string
        let contractData = {
            mydibelLogo: MYDIBEL_LOGO_2,
            contractTitle: title,
            declarationTitle: declarartionTitle,
            clientName: supplier.Name,
            clientStreetAndNumber: supplier.Street,
            clientZipAndCity: supplier.Zipcode + ' ' + supplier.City,
            clientCountry: supplierCountryName,
            clientVAT: supplier.VatNr,
            remarksSection: CreateRemarksAndFreeClausesHtml(purchaseOrder, supplier.LanguageID, certificateNumber, validUntil, supplier.Name),
            contractConditions: CreateContractConditionsSectionHtml(contractConditions, supplier.LanguageID),
            purchaseOrderLineRows: CreateOrderLinesHtml(purchaseOrder.purchaseOrderLines, supplier.LanguageID),
            totalRow: CreateTotalLineHtml(purchaseOrder.purchaseOrderLines, purchaseOrder.unitOfMeasurementID, supplier.LanguageID),
            validUntill: CreateValidUntillSection(purchaseOrder, supplier.LanguageID, language.LanguageCode),
            contractDate: new Date(purchaseOrder.contractDate).toLocaleString(language.LanguageCode, { month: 'long', day: 'numeric', year: 'numeric' }),
            approvalBoxBruno: approvalBoxBruno,
            approvalBoxFrederik: approvalBoxFrederik,
            brokerApprovalBox: CreateBrokerApprovalBox(broker, supplier.LanguageID),
            forApprovalBoxWidth: broker.IsManager ? 28 : 19  // als er 4 zijn, afhankelijk van broker type, nog niet in API
        }

        contractHtml = _mustache.render(contractHtml, contractData);

        let nextYear = parseInt(purchaseOrder.harvestYear) + 1;

        let paymentTerm = _localStore.paymentTerms.find((p) => { return p.ID === supplier.PaymentTermID });
        let paymentTermName = GetTranslatedValue(supplier.LanguageID, paymentTerm.NameTranslationID, _localStore.translations, _localStore.translationValues, paymentTerm.Name);

        let transportType = _localStore.transportTypes.find((tt) => { return tt.ID === purchaseOrder.transportTypeID });
        let transportTypeName = GetTranslatedValue(supplier.LanguageID, transportType.NameTranslationID, _localStore.translations, _localStore.translationValues, transportType.Name);

        let transportPrice = "";

        if (purchaseOrder.transportPrice100Kg
            && purchaseOrder.transportPrice100Kg !== ''
            && parseFloat(purchaseOrder.transportPrice100Kg) > 0) {
            transportPrice = "(" + ToCurrencyString(purchaseOrder.transportPrice100Kg) + "€/100kg)";
        }

        // let toLog = purchaseOrder.purchaseOrderLines[0];
        // for(var propName in toLog) {
        //     propValue = toLog[propName]
        //     console.log(propName,propValue);
        // }

        // console.log(purchaseOrder.purchaseOrderLines[0].contractPrice);

        // Fields replacing in DB texts:

        let contractPrice = ""
        if (purchaseOrder.purchaseOrderLines.length > 0) {
            contractPrice = purchaseOrder.purchaseOrderLines[0].contractPrice
        }

        let dataFromDb = {
            Year: purchaseOrder.harvestYear,
            PaymentTermName: paymentTermName,
            Season: purchaseOrder.harvestYear + ' - ' + nextYear,
            Oogstjaar: purchaseOrder.harvestYear,
            TransportType: transportTypeName,
            TransportPrice: transportPrice,
            TonPerHa: contractPrice,
            certNumber: certificateNumber,
            certValidUntil: validUntil,
            supplier: supplier.Name
        }

        contractHtml = _mustache.render(contractHtml, dataFromDb);


        return contractHtml;
    }
    catch (error) {
        return CreateErrorHtml(error);
    }
}
